//--------------- IMPORTAÇÕES ---------------//
import "react-toastify/dist/ReactToastify.css";
import { LoadingContext } from "../../shared/context/LoadingContext";
import { Loading } from "../../shared/components";
import { useContext, useEffect } from "react";
import { loadCompaniesService } from "./services";
import { EmpresasContext } from "./context/EmpresasContext";
import { Main } from "./components";



//--------------- EXPORTAÇÃO DA PÁGINA EMPRESAS ---------------//
export default function Empresas() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const {empresas, setEmpresas} = useContext(EmpresasContext);
  const {isLoading, setIsLoading} = useContext(LoadingContext);



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleLoadingCompanies();
  }, []);



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE LOADING COMPANIES ---------------//
    async function handleLoadingCompanies() {
        setIsLoading(true);
        const response = await loadCompaniesService();
        if (response) {
            setEmpresas(response.data);
            console.log(response.data)
        }
        setIsLoading(false);
    }



  //--------------- RETORNO CONDICIONAL DA PÁGINA EMPRESAS ---------------//
  return (
    <>
      {isLoading || empresas === null ? <Loading /> : <Main />}
    </>
  )
}